export default "__VITE_ASSET__DQl49feH__"